import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
  Typography,
} from "@mui/material";

export default function CatalogCategorySelect({ catalogCategory, setCatalogCategory }) {
  const handleChange = (e) => {
    const value = e.target.value;
    setCatalogCategory(value === "none" ? null : value);
  };

  return (
    <FormControl component="fieldset" fullWidth>
      <Stack>
        <FormLabel component="legend" sx={{ fontSize: "0.75rem", mb: -1, mt: 1 }}>
          Catalog Category
        </FormLabel>
        <RadioGroup row value={catalogCategory || "none"} onChange={handleChange}>
          <FormControlLabel
            value="none"
            control={<Radio size="small" color="primary" />}
            label={<Typography sx={{ fontSize: "0.75rem" }}>Any</Typography>}
          />
          <FormControlLabel
            value="gold"
            control={<Radio size="small" color="primary" />}
            label={<Typography sx={{ fontSize: "0.75rem" }}>Gold</Typography>}
          />
          <FormControlLabel
            value="silver"
            control={<Radio size="small" color="primary" />}
            label={<Typography sx={{ fontSize: "0.75rem" }}>Silver</Typography>}
          />
          <FormControlLabel
            value="onnme"
            control={<Radio size="small" color="primary" />}
            label={<Typography sx={{ fontSize: "0.75rem" }}>Onnme</Typography>}
          />
        </RadioGroup>
      </Stack>
    </FormControl>
  );
}
